import React, { PropsWithChildren } from 'react';
import Linkify from 'linkify-react';

import { BaseComponent } from '..';

import { linkifyOptions } from './options';

export interface EvoachLinkifyComponent extends BaseComponent {
  type: 'evoachLinkify';
  props: EvoachLinkifyProps;
}

export interface EvoachLinkifyProps {
  options?: object;
}

export const EvoachLinkify: React.FC<PropsWithChildren<EvoachLinkifyProps>> = ({
  children,
  options = {},
}) => {
  return (
    <>
      <Linkify options={{ ...linkifyOptions, ...options }}>{children}</Linkify>
    </>
  );
};

export default EvoachLinkify;
